import Iconify from "../../../../../../../components/Iconify";

export default function RenderIconOnButtons({ icon }) {
    return (
        <Iconify
            icon={icon}
            sx={{ mr: 1 }}
        />
    )
}